<template>
  <div class="transform">
    <div class="transform_top">提现详情</div>
    <div class="transform_content">
      <div class="transform_content_tx">
        <div class="transform_content_tx_cg">
          <div>
            <img
              class="transform_content_tx_cg_img"
              src="../../../assets/images/licai/tjcg.png"
            />
          </div>
          <div class="transform_content_tx_cg_2">提现申请提交成功</div>
          <div class="transform_content_tx_cg_3">
            提现后24小时内到账,若未及时到账,请联系平台<br />客服人员
          </div>
        </div>
        <div class="transform_content_tx_fgx"></div>
        <div class="transform_sk">
          <div class="transform_sk_zh">收款账户</div>
          <div class="">{{ $route.query.cardName }}</div>
        </div>
        <div class="transform_tx">
          <div class="transform_tx_je">收款金额</div>
          <div class="">{{ $route.query.money }}元</div>
        </div>
      </div>
      <div class="transform_return">
        <div class="transform_return1" @click="$router.go(-1)">返回</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data: function() {
    return {};
  },
  mounted: function() {},
  methods: {}
};
</script>

<style scoped>
.transform {
  width: 100%;
  height: 100%;
}

.transform_top {
  font-size: 18px;
  color: #000;
  line-height: 40px;
  text-align: center;
}

.transform_content {
  height: 100%;
  background: rgb(237, 237, 237);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  /*justify-content: center;*/
}

.transform_content_tx {
  flex: 1;
  width: 90%;
  /* height: 60%; */
  margin-top: 10px;
  background: #ffffff;
  border-radius: 5px 5px;
  display: flex;
  flex-direction: column;
  padding-left: 10px;
  padding-right: 10px;
  padding-bottom: 30px;
}

.transform_content_tx_cg {
  margin-top: 80px;
  display: flex;
  flex-direction: column;
  text-align: center;
}

.transform_content_tx_cg_img {
  width: 100px;
  height: 100px;
}

.transform_content_tx_cg_2 {
  /*margin-top: 10px;*/
  font-weight: bold;
}

.transform_content_tx_cg_3 {
  /*color: ;*/
  margin-top: 10px;
  color: grey;
}

.transform_content_tx_fgx {
  margin-top: 100px;
  height: 1px;
  background: grey;
}

.transform_sk {
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
  color: grey;
}

.transform_sk_zh {
  font-weight: bold;
  color: black;
}

.transform_tx {
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
  color: grey;
}

.transform_tx_je {
  font-weight: bold;
  color: black;
}

.transform_return {
  margin-top: 20px;
  flex: 1;
  width: 90%;
}

.transform_return1 {
  width: 100%;
  height: 50px;
  border-radius: 5px 5px;
  background: #ff1900;
  color: #ffffff;
  line-height: 50px;
  text-align: center;
}
</style>
